import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/** Saves the active selection after Current List params are applied. */
export const applySelectionsOnParamsApplied = store.effects.create(
  <TTypeParams extends Plugin.TypeParams>(
    _feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
    appliedSelectionStorage: Plugin['_appliedSelectionStorage'],
  ) =>
    plugin.collection.plugins.currentListPlugin.feature.actions.applyParams.success
      .observe()
      .pipe(
        rxjsUtils.latestFrom(action => ({
          action: rxjs.of(action),
          selectionLookup: plugin.selectors.selectionLookup.asObservable,
        })),
        rxjs.map(({ action, selectionLookup }) =>
          appliedSelectionStorage.actions.setLookup
            .from(action)
            .create(selectionLookup),
        ),
      ),
)
